/**
 * Throttles scroll event so it fires only once every x miliseconds.
 */
import styles from './styles';

const scroll = () => {
  const scrollThrottleTime = 300;
  const throttledScrollEvent = new Event('qustodio:throttledScroll');
  let documentHeight;
  let windowHeight;
  let currentPosition;
  let lastScrollTime;
  let body;

  const disableBodyScroll = () => {
    body.classList.add(styles.cssClass.NO_SCROLL);
  };

  const enableBodyScroll = () => {
    body.classList.remove(styles.cssClass.NO_SCROLL);
  };

  const updateHeight = () => {
    documentHeight = document.documentElement.scrollHeight;
    windowHeight = window.innerHeight;
  };

  const updateCurrentPosition = () => {
    currentPosition = window.scrollY;
  };

  const updateLastScrollTime = () => {
    lastScrollTime = Date.now();
  };

  const exceededThrottleTime = () => {
    const currentScrollTime = Date.now();
    return (lastScrollTime + scrollThrottleTime) < currentScrollTime;
  };

  const reachedTop = () => currentPosition === 0;

  const reachedBottom = () => (currentPosition + windowHeight) >= documentHeight;

  const throttle = () => !(exceededThrottleTime() || reachedTop() || reachedBottom());

  const onScroll = () => {
    updateCurrentPosition();
    if (!throttle()) {
      window.dispatchEvent(throttledScrollEvent);
      updateLastScrollTime();
    }
  };

  const init = () => {
    body = document.querySelector('body');
    updateHeight();
    updateCurrentPosition();
    updateLastScrollTime();
    window.addEventListener('scroll', onScroll);
  };

  const onResize = () => {
    updateHeight();
    updateCurrentPosition();
  };

  const getCurrentPosition = () => currentPosition;

  return {
    init,
    onResize,
    getCurrentPosition,
    disableBodyScroll,
    enableBodyScroll,
  };
};

export default scroll();
